import { PieChart } from "react-minimal-pie-chart";
import KwilDB from "kwildb";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import FundingPool from "./funding-components/FundingPool";

export default function FundingView({ selectedPools, privKey, secret, update }) {
    const moatName = useSelector((state) => state.loadedMoat.value)
    const [totalFunds, setTotalFunds] = useState(0)
    const [totalData, setTotalData] = useState(0)
    const [usedFunds, setUsedFunds] = useState(0)
    const [usedData, setUsedData] = useState(0)

    useEffect(() => {
        setTimeout(async function () {
            const kwilDB = KwilDB.createConnector(
                {
                    host: "test-db.kwil.xyz",
                    protocol: "https",
                    port: null,
                    moat: moatName,
                    privateKey: privKey
                },
                secret
            )
            const total = await kwilDB.getMoatFunding()
            setTotalFunds(total.funding)
            setTotalData(Math.round((total.funding / (8.5 * 1.3)) * 1000000000))

            const used = await kwilDB.getMoatDebit()
            setUsedFunds = ((used.debit / 1000000000) * 8.5 * 1.3)
            setUsedData(used.debit)
        })
    }, [privKey, update])
    
    return(
        <div className="funding-view">
            {selectedPools.length > 0 ? (
                <Helmet>
                    <title>Funding | {moatName} | KwilDB</title>
                </Helmet>
            ) : <></>}
            <p className="table-title">Funding Pools</p>
            <div
                style={{
                    margin: "20px 40px",
                    display: totalFunds !== 0 ? "flex" : "none"
                }}
            >
                <div style={{ width: "100px", height: "100px"}}>
                    <PieChart
                        data={[{ title: "Used", value: usedFunds, color: "linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)"}]}
                        totalValue={totalFunds}
                        background="#12499E"
                        viewBoxSize={[100, 100]}
                        lineWidth={15}
                        rounded
                        label={({ dataEntry }) =>
                            Math.round((dataEntry.value * 1000) / totalFunds) / 10 + "%"
                        }
                        labelStyle={{
                            fontSize: "20px",
                            fontFamily: "sans-serif",
                            fill: "#fff",
                        }}
                        labelPosition={0}
                    />
                </div>
                <div className="funding-card">
                    <p>{usedFunds < 0.01 ? "Funding Used: < 0.01 USD" : `Funding Used: ${usedFunds} USD`}</p>
                    <p>{totalFunds < 0.01 ? "Total Funds Available: < 0.01 USD" : `Total Funds Available: ${Math.round(totalFunds * 100) / 100} USD`}</p>
                </div>
                <div className="funding-card">
                    <p>
                        {usedData > 1000
                            ? usedData > 1000000
                                ? usedData > 1000000000
                                    ? `Data Used: ${usedData / 1000000000} GB`
                                    : `Data Used: ${usedData / 1000000} MB`
                                : `Data Used: ${usedData / 1000} KB`
                            : `Data Used: ${usedData} Bytes`}
                    </p>
                    <p>
                    {totalData > 1000
                            ? totalData > 1000000
                                ? totalData > 1000000000
                                    ? `Total Data Available: ${totalData / 1000000000} GB`
                                    : `Total Data Available: ${totalData / 1000000} MB`
                                : `Total Data Available: ${totalData / 1000} KB`
                            : `Total Data Available: ${totalData} Bytes`}
                    </p>
                </div>
            </div>
            <Grid
                container
                spacing={2}
                sx={{
                    margin: "0 20px 20px",
                    width: "calc(100% - 280px)"
                }}
            >
                {selectedPools.map((pool, index) => {
                    return(
                        <Grid item xs={6}>
                            <FundingPool
                                key={index}
                                pool={JSON.parse(pool)}
                                totalFunds={totalFunds}
                                setTotalFunds={setTotalFunds}
                                setTotalData={setTotalData}
                            />
                        </Grid>
                    )
                })}
            </Grid>
        </div>
    )
}